import _defineProperty2 from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './Phone.css';
import React, { useEffect, useState } from 'react';
import { PhoneInput } from './PhoneInput/PhoneInput';
var BASE_URL = process.env.REACT_APP_MEDIA_HOST ? process.env.REACT_APP_MEDIA_HOST : '';
var Phone = function Phone(props) {
  var _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    _props$label = props.label,
    label = _props$label === void 0 ? 'phone' : _props$label,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
    _props$name = props.name,
    name = _props$name === void 0 ? 'phone' : _props$name,
    _props$rtl = props.rtl,
    rtl = _props$rtl === void 0 ? false : _props$rtl,
    _props$patternInvalid = props.patternInvalidMessage,
    patternInvalidMessage = _props$patternInvalid === void 0 ? 'validateError' : _props$patternInvalid,
    _props$validate = props.validate,
    validate = _props$validate === void 0 ? false : _props$validate,
    contextValue = props.value,
    _props$code = props.code,
    contextCode = _props$code === void 0 ? '' : _props$code,
    _props$countryValues = props.countryValues,
    countryValues = _props$countryValues === void 0 ? [] : _props$countryValues,
    updateContext = props.updateContext,
    _props$code2 = props.code,
    code = _props$code2 === void 0 ? '' : _props$code2,
    _props$isDisablePlus = props.isDisablePlus,
    isDisablePlus = _props$isDisablePlus === void 0 ? false : _props$isDisablePlus;
  var _useState = useState({
      number: '',
      code: '',
      valid: true
    }),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    inValid = _useState4[0],
    setInValid = _useState4[1];
  var onChangeEvent = function onChangeEvent(val) {
    if (val.valid) required && setInValid(!val.valid);
    setValue(function (v) {
      return _objectSpread(_objectSpread({}, v), val);
    });
  };
  var validating = function validating(val) {
    required && setInValid(!val.valid);
  };
  useEffect(function () {
    if (validate) required && setInValid(!value.valid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validate]);
  useEffect(function () {
    if (contextValue && contextValue.length) {
      setValue(function (val) {
        return _objectSpread(_objectSpread({}, val), {
          number: contextValue,
          code: contextCode.length ? contextCode : val.code
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextValue, code, contextCode]);
  useEffect(function () {
    if (value.number.length || value.code.length) {
      updateContext(_defineProperty2({}, name, _objectSpread(_objectSpread({}, props), {}, {
        valid: required && value.valid,
        value: "".concat(value.number),
        code: "".concat(isDisablePlus ? value.code.replace('+', '') : value.code)
      })));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return /*#__PURE__*/React.createElement("fieldset", {
    className: " ".concat(commonStyles, "  ").concat(rtl ? rtlStyles : ltrStyles, " ")
  }, /*#__PURE__*/React.createElement("label", {
    className: "body-small wiz__label ",
    htmlFor: name
  }, label), /*#__PURE__*/React.createElement(PhoneInput, {
    countryItems: countryValues.map(function (el) {
      return {
        code: el.countryCode.jss.value,
        countryName: el.countryName.jss.value,
        text: el.phoneCode.jss.value,
        value: el.phoneCode.jss.value,
        flag: el.flag.jss.value.alt,
        flagSrc: "".concat(BASE_URL, "/").concat(el.flag.jss.value.src)
      };
    }),
    name: name,
    code: contextCode,
    placeholder: placeholder,
    onChange: function onChange(val) {
      return onChangeEvent(val);
    },
    onBlur: function onBlur(val) {
      return validating(val);
    },
    value: value,
    phoneInputClass: "form-field__phone-input ".concat(inValid ? ' invalid-field' : ''),
    required: required,
    customLayout: true,
    minLength: 9,
    maxLength: 14
  }), inValid && /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("p", {
    className: "text-input__error"
  }, patternInvalidMessage)));
};
var commonStyles = "c1gjv6a2";
var rtlStyles = "r9nldya";
var ltrStyles = "l11vpw5w";
export default Phone;